module.exports = __webpack_public_path__ + "d0f7d5e850895dfefd614bac3b392752.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Source/baikal_mobile.png
// module id = 407
// module chunks = 0